// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyListingAliasRetrieverWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

interface GetListingAliasForListingIdParams {
  listingId: string;
  originalUrl?: string;
}

export const RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Path =
  '/api/web/v1/users/properties/getListingAliasForListingId';

/**
 * Retrieve a listing alias from listing id
 */
export const RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId = (
  getParams: GetListingAliasForListingIdParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetListingAliasForListingIdParams, never, string>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
